import { elementLoadScript } from "./import-html-entry";

const shareLibsSet = new Set();

export function initShareLibs(LibObj) {
    let sharePromiseList = [];
    for (const [key, value] of Object.entries(LibObj)) {
        if (!shareLibsSet.has(key)) {
            shareLibsSet.add(key)
            sharePromiseList.push(elementLoadScript(value));
        }
    }
    return Promise.all(sharePromiseList);
}